import { create } from "zustand";
import type { PortfolioGraphInterval } from "@/components/portfolio/portfolio.utils";
import type { LockedPositionStore, StakingPositionStore, UnwindingPositionStore } from "@/hooks";

type SelectedPosition =
    | { type: "locked"; key: string; position: LockedPositionStore }
    | { type: "staked"; key: string; position: StakingPositionStore }
    | { type: "unwinding"; key: string; position: UnwindingPositionStore };

export const usePortfolioStore = create<{
    positionType: "staked" | "locked";
    setPositionType: (type: "staked" | "locked") => void;
    graphInterval: PortfolioGraphInterval;
    setGraphInterval: (interval: PortfolioGraphInterval) => void;
    selectedPosition: SelectedPosition | null;
    setSelectedPosition: (position: SelectedPosition | null) => void;
    resetSelection: () => void;
}>((set) => ({
    positionType: "locked",
    setPositionType: (type) => set({ positionType: type }),
    graphInterval: 0,
    setGraphInterval: (interval: PortfolioGraphInterval) => set({ graphInterval: interval }),
    selectedPosition: null,
    setSelectedPosition: (position) => set({ selectedPosition: position }),
    resetSelection: () => set({ selectedPosition: null }),
}));
